// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"bfb5fa8d","428":"e58d4622","586":"7332827e","604":"afac0808","714":"6410288f","751":"2dd5f446","816":"e645c7f3","910":"0c4181dd"}[chunkId] + ".chunk.css";
};